import {RouteDefinition, RouteParams, RouteRender} from '../../routing-configuration/route-definition/route-definition';
import {IRoute} from "./route.interface";
import React from "react";

export class FallbackRoute implements IRoute{
  private readonly _routeDefinition: RouteDefinition;

  constructor(render: RouteRender) {
    this._routeDefinition = {
      paths: [],
      render: render
    }
  }

  render(): React.ReactNode {
    return this._routeDefinition.render(this.routeParams);
  }

  get routeParams(): RouteParams {
    return {};
  }

  get isOrbitRoute(): boolean {
    return false;
  }

  get data(): any {
    return {};
  }

  get routeDefinition(): RouteDefinition {
    return this._routeDefinition;
  }

  protected  _isMiniOrbitRoute(): boolean {
    return false;
  }
}
